export default __webpack_public_path__ + "static/media/Furniture.a42021c7.png";